import FpTitle from './FpTitle.jsx'

export default FpTitle
